import { createSelector } from 'reselect'
import charactersSelector from '../app/charactersSelector'
import skinSelector from '../app/skinSelector'
import playerDataSelector from '../app/playerDataSelector'

export default createSelector(charactersSelector, skinSelector, playerDataSelector, (characters, skin, playerData) => ({
	characters,
	skin: skin.login,
	deviceUid: playerData.deviceUid,
}))
